// Avatar color palette - soft pastels
const AVATAR_COLORS = [
  { bg: '#DDE7F5', text: '#3A6EA5' }, // Soft blue
  { bg: '#E9F5EE', text: '#2E7D5F' }, // Soft green
  { bg: '#F5EAF3', text: '#6E46A1' }, // Soft purple
  { bg: '#F5F1E9', text: '#8A7A5A' }, // Soft beige
  { bg: '#EFEFEF', text: '#5A5A5A' }, // Soft gray
  { bg: '#EAF3FC', text: '#3A6EA5' }, // Light blue
  { bg: '#E5F5ED', text: '#2E7D5F' }, // Light green
  { bg: '#F2EAFB', text: '#6E46A1' }, // Light purple
];

// Blob shapes - CSS border-radius patterns for organic shapes
const BLOB_SHAPES = [
  '60% 40% 30% 70% / 60% 30% 70% 40%', // Blob 1
  '40% 60% 60% 40% / 60% 30% 70% 40%', // Blob 2
  '40% 60% 70% 30% / 40% 50% 60% 50%', // Blob 3
  '70% 30% 50% 50% / 30% 50% 70% 50%', // Blob 4
  '50% 50% 30% 70% / 50% 70% 30% 50%', // Blob 5
];

// Generate a consistent color based on username
export const getAvatarColor = (username) => {
  if (!username) return AVATAR_COLORS[0];
  
  // Hash the username to get a consistent index
  let hash = 0;
  for (let i = 0; i < username.length; i++) {
    hash = username.charCodeAt(i) + ((hash << 5) - hash);
  }
  
  const index = Math.abs(hash) % AVATAR_COLORS.length;
  return AVATAR_COLORS[index];
};

// Generate a consistent blob shape based on username
export const getBlobShape = (username) => {
  if (!username) return BLOB_SHAPES[0];
  
  // Hash the username to get a consistent index
  let hash = 0;
  for (let i = 0; i < username.length; i++) {
    hash = username.charCodeAt(i) + ((hash << 5) - hash);
  }
  
  const index = Math.abs(hash) % BLOB_SHAPES.length;
  return BLOB_SHAPES[index];
};

// Get avatar style object
export const getAvatarStyle = (username) => {
  const color = getAvatarColor(username);
  const shape = getBlobShape(username);
  
  return {
    backgroundColor: color.bg,
    color: color.text,
    borderRadius: shape,
  };
};
